// Ideal Postcodes implementation of the DataSource interface. Closes over
// baseUrl and apiKey so callers don't have to thread credentials through every
// call. Country defaults to "GB" since the IDPC dataset is UK-only.

import {
  cleanseAddress as rawCleanseAddress,
  lookupByUprn as rawLookupByUprn,
  validateApiKey as rawValidateApiKey,
} from "../lib/api";
import type { DataSource } from "./source";

export interface IdpcConfig {
  baseUrl: string;
  apiKey: string;
}

export function createIdpcSource(config: IdpcConfig): DataSource {
  const { baseUrl, apiKey } = config;
  return {
    cleanseAddress: (query) =>
      rawCleanseAddress({
        baseUrl,
        apiKey,
        authMode: "query",
        body: { query, country: "GB" },
      }),
    lookupByUprn: (uprn) => rawLookupByUprn({ baseUrl, apiKey, uprn }),
    validateKey: () => rawValidateApiKey(baseUrl, apiKey),
  };
}
